module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-144x144-a8b0435d9e21cab72feee2dfdf19e96b.png";